export const checkIfGoogleMapsIsLoaded = () => {
    return typeof window !== 'undefined' && !!window.google;
}
